export class User {
    name: string;
    email_id: string;
    status: string;
    profile_image_url: string;
    _id: string;
    role: string;
    phone_no: string;
    created_by: string;
    updated_by: string;
    updated_at: string;
    created_at: string;
}
